import {
  Autocomplete,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
import AppFileImput from "../../../shares/AppFileImput";
import { CVService } from "../../../../../service/CVService";
import { useToastStore } from "../../../../../stores/toastStore";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import { useQuery } from "../../../../../hooks/useQuery";
import {
  enleverBaliseHtml,
  formatPhoneNumber,
  isValidEmail,
} from "../../../../../Helpers/utilsHelper";
import { uploadService } from "../../../../../service/UploadService";
import { CVExperienceService } from "../../../../../service/CVExperienceService";
import StandardSkeletoon from "../../../shares/loader/StandardSkeletoon";
const INIT_EXPERIENCE = {
  id_experience: null,
  date_debut_experience: null,
  date_fin_experience: null,
  organisme_experience: null,
  domaine_experience: null,
  sous_domaine_experience: null,
  statut: null,
  experience_mission: null,
  description_experience: null,
  reference: null,
  email_ref: null,
  num_ref: null,
  file_experience: null,
  fin_contrat: null,
};
const INIT_FORM_ERROR = {
  date_debut_experience_error: null,
  date_fin_experience_error: null,
  organisme_experience_error: null,
  domaine_experience_error: null,
  sous_domaine_experience_error: null,
  statut_error: null,
  experience_mission_error: null,
  description_experience_error: null,
  reference_error: null,
  email_ref_error: null,
  num_ref_error: null,
  file_experience_error: null,
  fin_contrat_error: null,
};
const ExperienceForm = ({ open, onFormClose, onFormOpen, idExperience }) => {
  const [currentExperience, setCurrentExperience] = useState(INIT_EXPERIENCE);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [isSubmited, setIsSubmited] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [optionsDomaineCompetence, setOptionsDomaineCompetence] = useState([]);
  const [optionsSousDomaineCompetence, setoptionsSousDomaineCompetence] =
    useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const showToastStore = useToastStore((state) => state.showToast);
  const query = useQuery();
  const id_ext_user = query.get("ref");
  const handleFormClose = () => {
    onFormClose();
    setFormErrors(INIT_FORM_ERROR);
    setCurrentExperience(INIT_EXPERIENCE);
    setIsSubmited(false);
  };

  const handleFetchDomaineCompetence = (filtre) => {
    setFormLoading(true);
    CVService.getDomaineList(filtre)
      .then((res) => {
        if (res && res.data) {
          setOptionsDomaineCompetence(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };
  const handleFetchSousDomaineCompetence = (filtre) => {
    CVService.getSousDomaineList(filtre).then((res) => {
      if (res && res.data) {
        setoptionsSousDomaineCompetence(res.data);
      }
    });
  };

  const handleInsertExperience = (experience) => {
    let copy_exp = { ...experience, id_ext_user: id_ext_user };
    setSubmitting(true);
    CVExperienceService.insert(copy_exp)
      .then((res) => {
        if (res && res.success) {
          showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  const handleUpdateExperience = (experience) => {
    setSubmitting(true);
    CVExperienceService.update(experience)
      .then((res) => {
        if (res && res.success) {
          showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    setIsSubmited(true);
    const ok = handleCheckError();
    if (ok) {
      setSubmitting(true);
      if (idExperience) {
        handleUpdateExperience(currentExperience);
      } else {
        handleInsertExperience(currentExperience);
      }
    } else {
      showToastStore(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleFetchExperience = () => {
    if (idExperience) {
      CVExperienceService.find_by_id(idExperience).then((res) => {
        if (res && res.success) {
          setCurrentExperience(res.data);
        }
      });
    }
  };

  const handleChangeCurrentExperience = (event) => {
    const { name, value } = event.target;
    setCurrentExperience((prevExperience) => ({
      ...prevExperience,
      [name]: value,
    }));
  };

  const handleCheckError = () => {
    const today = new Date();
    const dateDebut = new Date(currentExperience.date_debut_experience);
    const dateFin = new Date(currentExperience.date_fin_experience);
    setFormErrors({
      date_debut_experience_error: !currentExperience.date_debut_experience
        ? "Date de debut est requise"
        : dateDebut >= today
          ? "Date de debut doit etre au passé"
          : dateDebut > dateFin
            ? "Date de debut doit etre avant la date de fin"
            : null,
      date_fin_experience_error:
        !currentExperience.date_fin_experience &&
        currentExperience.fin_contrat !== "Présent"
          ? "Date de fin est requise"
          : null,
      organisme_experience_error: !currentExperience.organisme_experience
        ? "Lieu de travail est requis"
        : null,
      domaine_experience_error: !currentExperience.domaine_experience
        ? "Domaine est requis"
        : null,
      sous_domaine_experience_error: !currentExperience.sous_domaine_experience
        ? "Sous domaine est requis"
        : null,
      statut_error: !currentExperience.statut ? "Statut est requis" : null,
      experience_mission_error: !currentExperience.experience_mission
        ? "Titre du poste est requis"
        : null,
      description_experience_error: !currentExperience.description_experience
        ? "Description est requise"
        : null,
      reference_error: null,
      email_ref_error:
        currentExperience.email_ref &&
        !isValidEmail(currentExperience.email_ref)
          ? "Mail est invalide"
          : null,
      num_ref_error: null,
      file_experience_error: null,
      fin_contrat_error: null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleFileUpload = (file) => {
    setFormErrors({
      ...formErrors,
      file_experience_error: "Telechargement du fichier en cours...",
    });
    uploadService.uploadFile(file).then((res) => {
      if (!(res && res.success)) {
        showToastStore(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
      }
      setCurrentExperience({
        ...currentExperience,
        file_experience: res && res.success ? res.data.file_name : null,
      });
      setFormErrors({
        ...formErrors,
        file_experience_error:
          res && res.success ? null : enleverBaliseHtml(res.error),
      });
    });
  };

  useEffect(() => {
    if (open || idExperience) {
      handleFetchExperience();
      handleFetchDomaineCompetence();
      handleFetchSousDomaineCompetence();
    }
  }, [open, idExperience]);

  useEffect(() => {
    if (selectedFile) {
      handleFileUpload(selectedFile);
    }
  }, [selectedFile]);

  useEffect(() => {
    handleCheckError();
  }, [currentExperience]);

  return (
    <>
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="sm">
        <Paper sx={{ m: 3 }} elevation={0}>
          <StandardSkeletoon show={formLoading} escalier row={3} />
          <Grid display={formLoading ? "none" : ""}>
            <CardHeader title="Experience" />
            <CardContent sx={{ maxHeight: "72vh", overflow: "auto" }}>
              <Grid container>
                <Grid item /* pl={1} pr={1} */>
                  <FormControl fullWidth>
                    <label>Titre du poste *</label>
                    <TextField
                      id="experience_mission"
                      name="experience_mission"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      placeholder="Titre du poste *"
                      fullWidth
                      value={currentExperience.experience_mission}
                      error={formErrors.experience_mission_error && isSubmited}
                      helperText={
                        isSubmited ? formErrors.experience_mission_error : ""
                      }
                      aria-describedby="nom_helper"
                    />
                    <FormHelperText id="nom_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Date debut</label>
                    <TextField
                      id="date_debut_experience"
                      name="date_debut_experience"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="date"
                      placeholder="Date debut"
                      fullWidth
                      sx={{
                        "& input": {
                          textAlign: "right",
                        },
                      }}
                      value={
                        currentExperience.date_debut_experience
                          ? currentExperience.date_debut_experience.slice(0, 10)
                          : ""
                      }
                      error={
                        formErrors.date_debut_experience_error && isSubmited
                      }
                      helperText={
                        isSubmited ? formErrors.date_debut_experience_error : ""
                      }
                      aria-describedby="date_debut_helper"
                    />
                    <FormHelperText id="date_debut_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Date fin *</label>
                    <FormControlLabel
                      // sx={{ mt: 1.5, mb: 2 }}
                      control={
                        <Checkbox
                          checked={currentExperience.fin_contrat === "Présent"}
                          onChange={(evt) => {
                            setCurrentExperience((prev) => ({
                              ...prev,
                              fin_contrat: evt.target.checked
                                ? "Présent"
                                : null,
                              date_fin_experience: !evt.target.checked
                                ? new Date().toISOString().slice(0, 10)
                                : "",
                            }));
                          }}
                          name="fin_contrat"
                        />
                      }
                      label="J'y travail à présent"
                    />
                    <TextField
                      disabled={currentExperience.fin_contrat === "Présent"}
                      id="date_fin_experience"
                      name="date_fin_experience"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="date"
                      placeholder="Année d'obtention du diplôme"
                      fullWidth
                      sx={{
                        "& input": {
                          textAlign: "right",
                        },
                        display:
                          currentExperience.fin_contrat === "Présent"
                            ? "none"
                            : "",
                      }}
                      value={
                        currentExperience.date_fin_experience
                          ? currentExperience.date_fin_experience.slice(0, 10)
                          : ""
                      }
                      error={formErrors.date_fin_experience_error && isSubmited}
                      helperText={
                        isSubmited ? formErrors.date_fin_experience_error : ""
                      }
                      aria-describedby="date_fin_helper"
                    />
                    <FormHelperText id="date_fin_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Etablissement *</label>
                    <TextField
                      id="organisme_experience"
                      name="organisme_experience"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      placeholder="Votre lieu de travail *"
                      type="text"
                      fullWidth
                      value={currentExperience.organisme_experience}
                      error={
                        formErrors.organisme_experience_error && isSubmited
                      }
                      helperText={
                        isSubmited ? formErrors.organisme_experience_error : ""
                      }
                      aria-describedby="organisme_helper"
                    />
                    <FormHelperText id="organisme_helper"></FormHelperText>
                  </FormControl>

                  <FormControl fullWidth>
                    <label>Statut</label>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="statut"
                      onChange={handleChangeCurrentExperience}
                      value={currentExperience.statut || "Salarié"}
                      aria-describedby="statut_helper"
                    >
                      <FormControlLabel
                        value="Salarié"
                        checked={currentExperience.statut === "Salarié"}
                        control={<Radio />}
                        label="Salarié"
                      />
                      <FormControlLabel
                        value="Consultant"
                        checked={currentExperience.statut === "Consultant"}
                        control={<Radio />}
                        label="Consultant"
                      />
                      <FormControlLabel
                        value="Stagiaire"
                        checked={currentExperience.statut === "Stagiaire"}
                        control={<Radio />}
                        label="Stagiaire"
                      />
                    </RadioGroup>
                    <FormHelperText
                      id="statut_helper"
                      sx={{
                        display: !(formErrors.statut_error && isSubmited)
                          ? "none"
                          : "block",
                        color: "error.main",
                      }}
                    >
                      {formErrors.statut_error}
                    </FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Domaine de competence *</label>
                    <Autocomplete
                      freeSolo
                      name="domaine_experience"
                      id="domaine_experience"
                      options={optionsDomaineCompetence.map(
                        (item) => item.name
                      )}
                      value={currentExperience.domaine_experience || ""}
                      onChange={(event, newValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "domaine_experience",
                            value: newValue || "",
                          },
                        });
                      }}
                      onInputChange={(event, newInputValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "domaine_experience",
                            value: newInputValue || "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          id="domaine_experience"
                          name="domaine_experience"
                          size="small"
                          placeholder="Domaine de competence"
                          fullWidth
                          error={
                            formErrors.domaine_experience_error && isSubmited
                          }
                          helperText={
                            isSubmited
                              ? formErrors.domaine_experience_error
                              : ""
                          }
                          aria-describedby="domaine_experience_helper"
                        />
                      )}
                    />
                    <FormHelperText id="domaine_competence_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Sous domaine de competence *</label>
                    <Autocomplete
                      freeSolo
                      name="sous_domaine_experience"
                      id="sous_domaine_experience"
                      options={
                        currentExperience.domaine_experience
                          ? optionsSousDomaineCompetence
                              .filter(
                                (item) =>
                                  (item.id__domaine &&
                                    item.id__domaine ===
                                      optionsDomaineCompetence.find(
                                        (item) =>
                                          item.name ===
                                          currentExperience.domaine_experience
                                      )?.id_domaine) ||
                                  0
                              )
                              .map((item) => item.name)
                          : []
                      }
                      value={currentExperience.sous_domaine_experience || ""}
                      onChange={(event, newValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "sous_domaine_experience",
                            value: newValue || "",
                          },
                        });
                      }}
                      onInputChange={(event, newInputValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "sous_domaine_experience",
                            value: newInputValue || "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          id="sous_domaine_experience"
                          name="sous_domaine_experience"
                          size="small"
                          placeholder="Sous domaine de competence"
                          fullWidth
                          error={
                            formErrors.sous_domaine_experience_error &&
                            isSubmited
                          }
                          helperText={
                            isSubmited
                              ? formErrors.sous_domaine_experience_error
                              : ""
                          }
                          aria-describedby="sous_domaine_experience_helper"
                        />
                      )}
                    />
                    <FormHelperText id="sous_domaine_experience_helper"></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item /* pl={1} pr={1} */>
                  <FormControl fullWidth>
                    <label>Description de vos taches</label>
                    <TextField
                      id="description_experience"
                      name="description_experience"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="text"
                      multiline
                      rows={4}
                      placeholder="Description de vos taches"
                      fullWidth
                      value={currentExperience.description_experience}
                      error={
                        formErrors.description_experience_error && isSubmited
                      }
                      helperText={
                        isSubmited
                          ? formErrors.description_experience_error
                          : ""
                      }
                      aria-describedby="description_experience_helper"
                    />
                    <FormHelperText id="description_experience_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Nom de la personne pour reference à ce poste</label>
                    <TextField
                      id="reference"
                      name="reference"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="text"
                      placeholder="Nom complet de la personne reference"
                      fullWidth
                      value={currentExperience.reference}
                      error={formErrors.reference_error && isSubmited}
                      helperText={isSubmited ? formErrors.reference_error : ""}
                      aria-describedby="reference_helper"
                    />
                    <FormHelperText id="reference_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Telephone reference</label>
                    <TextField
                      id="num_ref"
                      name="num_ref"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="tel"
                      placeholder="032 12 456 12"
                      fullWidth
                      value={formatPhoneNumber(currentExperience.num_ref)}
                      error={formErrors.num_ref_error && isSubmited}
                      helperText={isSubmited ? formErrors.num_ref_error : ""}
                      aria-describedby="num_ref_helper"
                    />
                    <FormHelperText id="num_ref_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Email reference</label>
                    <TextField
                      id="email_ref"
                      name="email_ref"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="email"
                      placeholder="Adresse email"
                      fullWidth
                      value={currentExperience.email_ref}
                      error={formErrors.email_ref_error && isSubmited}
                      helperText={isSubmited ? formErrors.email_ref_error : ""}
                      aria-describedby="email_ref_helper"
                    />
                    <FormHelperText id="email_ref_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Attestation/Certificat</label>
                    <AppFileImput
                      name="file_experience"
                      placeholder={"Attestation"}
                      handleFileUpload={(evt) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "file_experience",
                            value: evt.target.files[0]?.name || "",
                          },
                        });
                        setSelectedFile(evt.target.files[0]);
                      }}
                      handleClearFile={(evt) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "file_experience",
                            value: null,
                          },
                        });
                        setSelectedFile(null);
                      }}
                      file_name={currentExperience.file_experience || ""}
                      allowedFIle={".jpeg,.jpg,.png,.pdf,.docx"}
                      error={formErrors.file_experience_error}
                      helperText={formErrors.file_experience_error}
                    />
                    <FormHelperText id="file_helper"></FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={submitting}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={handleSubmit}
              />
              <AppButton
                size={"medium"}
                text={"Fermer"}
                variant={"outlined"}
                onClick={handleFormClose}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default ExperienceForm;
